import { gql } from '@apollo/client';

export const TOKEN_CREATE = gql`
    mutation TokenCreate($email: String!, $password: String!){
        tokenCreate(email: $email, password: $password) {
            token
            refreshToken
            csrfToken
            user {
                id
                email
                isStaff
                userPermissions {
                    code
                    name
                }
                wishlists (first: 1) {
                    edges {
                        node {
                            id
                        }
                    }
                }
            }
            accountErrors {
                field
                message
                code
            }
        }
    }`;
